import { render, staticRenderFns } from "./SchemeDetails.vue?vue&type=template&id=5ca5a6c8&"
import script from "./SchemeDetails.vue?vue&type=script&lang=js&"
export * from "./SchemeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports